import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import * as ReactDOM from 'react-dom';
import { StaffClient, StaffWidgetsClient } from '@skbkontur/staff-common';
import { EmployeeListSidePage } from './EmployeeListSidePage';
import { getPageSize } from './StaffWidget.helpers';
class EmployeeListSidePageStatic {
    static show(props) {
        if (this.container.current) {
            this.container.current.show(props);
        }
    }
    static mapToProps(options) {
        const staffClient = new StaffClient({ url: options.staffApiUrl });
        const widgetsClient = new StaffWidgetsClient({ url: options.staffWidgetsApiUrl });
        const pageSize = getPageSize();
        return {
            staffClient,
            widgetsClient,
            isSingleSelection: options.mode === 'single',
            clientName: options.productId,
            employerId: options.employerId,
            initialState: options.initialState,
            additionalColumn: options.additionalColumn,
            submitButtonText: options.submitButtonText,
            metricsOptions: options.context,
            fields: options.card?.fields || {},
            theme: options.theme,
            listType: options.listType,
            filters: options.filters,
            hasEmployeeSelected: options.selected,
            onContactSupport: options.onContactSupport,
            onSubmit: () => Promise.resolve(),
            onClose: () => {
                // nope
            },
            ignoreBackgroundClick: options.ignoreBackgroundClick,
            blockBackground: options.blockBackground,
            pageSize: options.pageSize || pageSize,
        };
    }
    static render(props) {
        if (!this.element) {
            this.element = document.createElement('div');
            document.body.appendChild(this.element);
            ReactDOM.render(_jsx(EmployeeListSidePageContainer, { ref: this.container }), this.element, () => this.show(props));
        }
        else {
            this.show(props);
        }
    }
}
Object.defineProperty(EmployeeListSidePageStatic, "container", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: React.createRef()
});
export class StaffWidget {
    constructor(options) {
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.options = options;
    }
    getEmployeeList(options) {
        const props = EmployeeListSidePageStatic.mapToProps({
            ...this.options,
            ...options,
        });
        EmployeeListSidePageStatic.render(props);
        return new Promise((resolve) => {
            props.onSubmit = async (employees) => resolve({ employees });
            props.onClose = () => resolve({ employees: [] });
        });
    }
}
class EmployeeListSidePageContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        if (!this.state.props) {
            return null;
        }
        return (_jsx(EmployeeListSidePage, { ...this.state.props, onSubmit: (employees) => this.submit(employees), onClose: () => this.close() }));
    }
    show(props) {
        this.setState({ props });
    }
    async submit(employees) {
        if (this.state.props) {
            await this.state.props.onSubmit(employees);
        }
        this.setState({ props: undefined });
    }
    close() {
        if (this.state.props) {
            this.state.props.onClose();
        }
        this.setState({ props: undefined });
    }
}
